import React from "react";
import { useRouter } from "@/router/Router";
import { useCart } from "@/state/CartContext";
import { useIsBrowserFallback } from "@/lib/hooks";

export function TopBar({
  title,
  onBack,
  showCart = true,
  brand = false,
}: {
  title: string;
  onBack?: () => void;
  showCart?: boolean;
  /** Home screen: show the KMS ROASTING logo instead of a text title. */
  brand?: boolean;
}) {
  const { navigate } = useRouter();
  const { totalItems } = useCart();
  const isBrowserFallback = useIsBrowserFallback();

  return (
    <header className="topbar">
      {onBack && isBrowserFallback && (
        <button className="topbar__back" onClick={onBack} aria-label="Back">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M15 5 8 12l7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      )}
      {brand ? (
        <button className="topbar__brand" onClick={() => navigate({ name: "home" })} aria-label={title}>
          <img src="/brand/kms-logo.png" alt="KMS ROASTING" />
        </button>
      ) : (
        <h1 className="topbar__title">{title}</h1>
      )}
      {showCart && (
        <button className="topbar__action" data-cart-target onClick={() => navigate({ name: "cart" })} aria-label="Cart">
          <svg width="21" height="21" viewBox="0 0 24 24" fill="none">
            <path
              d="M3 4h2l1.6 10.6a2 2 0 0 0 2 1.7h8a2 2 0 0 0 2-1.7L20 8H6"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle cx="9.5" cy="20" r="1.4" fill="currentColor" />
            <circle cx="16.5" cy="20" r="1.4" fill="currentColor" />
          </svg>
          {totalItems > 0 && <span className="topbar__badge">{totalItems}</span>}
        </button>
      )}
    </header>
  );
}
